/* 🤖 this file was generated by svg-to-ts */
export const matIconKeyboardReturn: {
  name: 'keyboard-return';
  data: string;
} = {
  name: 'keyboard-return',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M19 7v4H5.83l3.58-3.59L8 6l-6 6 6 6 1.41-1.41L5.83 13H21V7h-2z"/></svg>`
};
